import axios from "../config/axios";
import toast from "react-hot-toast";
import { UserApi } from "../Components/Apis";

export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

export const setUser = (user, token) => ({
  type: SET_USER,
  payload: { user, token },
});

export const clearUser = () => ({
  type: CLEAR_USER,
});

export const loginWithGoogle = (tokenId) => async (dispatch) => {
  if (!tokenId) {
    toast.error("Google authentication failed. No token received.");
    return;
  }

  const toastId = toast.loading("Signing you in...");

  try {
    const { data } = await axios.post(
      UserApi.Login,
      { tokenId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!data?.success) {
      throw new Error(data?.message || "Login failed");
    }

    const { user, token } = data;

    dispatch(setUser(user, token));

    toast.success("Login successful 🎉", { id: toastId });
  } catch (error) {
    console.error("Google Login Error:", error);

    toast.dismiss(toastId);
  }
};

export const ashokaLogin = (tokenId) => async (dispatch) => {
  if (!tokenId) {
    toast.error("Google authentication failed. No token received.");
    return;
  }

  const toastId = toast.loading("Signing you in...");

  try {
    const { data } = await axios.post(
      UserApi.AshokaLogin,
      { tokenId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!data?.success) {
      throw new Error(data?.message || "Login failed");
    }

    const { user, token } = data;

    dispatch(setUser(user, token));

    toast.success("Login successful 🎉", { id: toastId });
  } catch (error) {
    console.error("Google Login Error:", error);

    toast.dismiss(toastId);
  }
};

export const logout = () => (dispatch) => {
  dispatch(clearUser());
  toast.success("Logged out successfully!");
};
